import React from "react";
import "./LoadingOverlay.css";

const LoadingOverlay = ({ isVisible, message = "로딩 중..." }) => {
  if (!isVisible) return null;

  return (
    <div className="loading-overlay">
      <div className="loading-content">
        <div className="loading-spinner"></div>
        <p className="loading-message">{message}</p>
      </div>
    </div>
  );
};

export default LoadingOverlay;
